<template>
  <div class="container-image">
    <image-displayer :cdn_path="localCdnPath" :image_path="localImagePath" :btnClicked="btnClicked"></image-displayer>
    <div class="up-buttons">
      <div>
        <template v-if="!hideDelete">
          <b-button variant="danger" v-b-modal.confirm-modal @click="deleteImage" class="flex f-center f-j-center">
            <span class="icon-delete"></span>
          </b-button>
        </template>
        <div class="mt-2">
          <input
            id="inputfile"
            type="file" @change="fileChangeHandler"
            name="attachment" class="custom-file-input js-file-input__field">
          <b-button class="btn-img flex f-center f-j-center">
            <span class="icon-plus"></span>
          </b-button>
        </div>
        <b-button class="btn-img flex f-center f-j-center mt-2" @click="openImage">
          <span class="icon-eye"></span>
        </b-button>
      </div>
    </div>
    <small class="filename" v-if="fileUpdated">
      {{theFileName | if_null | truncate(40)}}
    </small>
  </div>
</template>

<script>
  import imageDisplayer from '~/components/template/form/image-displayer';
  export default {
    name: "blinki-input-file",
    props: ['image_path', 'cdn_path','file','ITEM_TYPES','ID', 'hideDelete'],
    components:{
      imageDisplayer
    },
    data() {
      return {
        image: null,
        files: [],
        labelPlaceholder: 'Aucun fichier choisi',
        fileUpdated: false,
        local_image_path:'',
        btnClicked:false
      }
    },
    model: {
      prop: 'file',
      event: 'fileChange'
    },
    methods: {
      openImage(){
        window.open(this.localImagePath ? (this.localCdnPath + this.localImagePath) : '/images/demo.jpg')
      },
      uploadImage() {
        this.fileUpdated = true;
        this.btnClicked=true;
      },
      deleteImage() {
        this.fileUpdated = false;
        this.btnClicked=true;
        this.local_image_path = "/images/camera.png";
        this.$emit('fileChange', null);
        this.clearFileHandler();
        const params = {
          action: 'item/delete',
          params: {
            record_type:this.ITEM_TYPES.apiId,
            record_id:this.ID,
            nextRequest:{
              action:this.ITEM_TYPES.storePath+'/removeImage',
              params:{id:this.ID}
            }
          }
        };
        this.$store.dispatch('confirm/setParams', params);
      },
      fileChangeHandler(e) {
        this.uploadImage();
        this.files = Array.from(e.target.files);
        this.$emit('fileChange', this.files[0])
        this.readURL();
      },
      clearFileHandler() {
        const el = this.$el.querySelector('.js-file-input__field');
        const wrapper = document.createElement('form');
        this.wrapInputAndReset(el, wrapper);
      },
      wrapInputAndReset(el, wrapper) {
        // wrap input with form tag
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);

        // reset input with form.reset()
        wrapper.reset();

        // place childNodes in document fragment
        const docFrag = document.createDocumentFragment();
        while (wrapper.firstChild) {
          const child = wrapper.removeChild(wrapper.firstChild);
          docFrag.appendChild(child);
        }

        // replace wrapper with document fragment
        wrapper.parentNode.replaceChild(docFrag, wrapper);

        this.files = [];
        this.showRemovedBtn = false;
      },
      readURL() {
        if (this.files && this.files[0]) {
          let reader = new FileReader();

          reader.onload =  (e) =>{
            this.local_image_path =  e.target.result;
          };

          reader.readAsDataURL(this.files[0]);
        }
      }
    },
    computed: {
      theFileName() {
        if ((this.files.length > 0) && 'name' in this.files[0]) {
          return this.files[0].name;
        }
        return this.labelPlaceholder;
      },
      localImagePath(){
        return this.btnClicked ? this.local_image_path : this.image_path
      },
      localCdnPath(){
        return this.btnClicked ? '' : this.cdn_path
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/css/theme.scss';

  /deep/ label {
    font-size: 14px;
  }


  .container-image{
    position: relative;
    height: 155px;
    display: flex;
  }



  .up-buttons {
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    border-radius: 50%;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
  }

  .custom-file-input::before {
    content: 'Select some files';
    display: inline-block;
    /*background: linear-gradient(top, #f9f9f9, #e3e3e3);*/
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
    width: 41px;
    height: 41px;
    overflow: hidden;
  }

  .custom-file-input:hover::before {
    border-color: black;
  }

  .custom-file-input:active::before {
    /*background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);*/
  }

  .custom-file-input {
    width: 40px;
    height: 40px;
    position: absolute;
  }

  .filename {
    background-color: $white-color;
    min-height: 25px;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 80px);
    bottom: 0;
    right: 80px;
  }

  .btn-img{
    background-color: $secondary-color;
    border: none;
  }

  [class^="icon-"]{
    height: 14px;
  }

  /deep/ .card-img{height: 138px !important;}

  /deep/ .displayer-img{
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /deep/ .image-box{
    border: 2px solid $primary-bg-color !important;
  }
</style>
